import { jwtDecode } from 'jwt-decode';
import { isBillingContext } from '../auth/roleUtils';

export function isBillingSession() {
  try {
    const token = localStorage.getItem('velaToken');
    return token ? isBillingContext(jwtDecode(token)) : false;
  } catch {
    return false;
  }
}

// A replay keeps the session that started it. Switching practice/persona
// cancels the request before a queued clinical write can use the next token.
export function createReplayContext() {
  const token = localStorage.getItem('velaToken');
  const controller = new AbortController();
  const stop = () => controller.abort();
  const storageChanged = event => {
    if (event.key === 'velaToken' && event.newValue !== token) stop();
  };
  window.addEventListener('vela:access-context-changed', stop);
  window.addEventListener('storage', storageChanged);
  return {
    token,
    signal: controller.signal,
    canContinue: () => !controller.signal.aborted && localStorage.getItem('velaToken') === token && !isBillingSession(),
    dispose: () => {
      window.removeEventListener('vela:access-context-changed', stop);
      window.removeEventListener('storage', storageChanged);
    },
  };
}
